// Simple API client for the Alice Lisi backend.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("al_admin_token");
export const setToken = (t) => localStorage.setItem("al_admin_token", t);
export const clearToken = () => localStorage.removeItem("al_admin_token");

const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const api = {
  login: async (password) => {
    const { data } = await axios.post(`${API}/auth/login`, { password });
    setToken(data.token);
    return data;
  },
  logout: () => clearToken(),
  me: async () => {
    const { data } = await axios.get(`${API}/auth/me`, { headers: authHeaders() });
    return data;
  },
  list: async (coll) => {
    const { data } = await axios.get(`${API}/${coll}`);
    return data;
  },
  create: async (coll, item) => {
    const { data } = await axios.post(`${API}/${coll}`, { data: item }, { headers: authHeaders() });
    return data;
  },
  update: async (coll, id, item) => {
    const { data } = await axios.put(`${API}/${coll}/${id}`, { data: item }, { headers: authHeaders() });
    return data;
  },
  remove: async (coll, id) => {
    const { data } = await axios.delete(`${API}/${coll}/${id}`, { headers: authHeaders() });
    return data;
  },
  reorder: async (coll, ids) => {
    const { data } = await axios.post(`${API}/${coll}/reorder`, { ids }, { headers: authHeaders() });
    return data;
  },
  upload: async (file) => {
    const form = new FormData();
    form.append("file", file);
    const { data } = await axios.post(`${API}/upload`, form, {
      headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    });
    return data; // { url, filename }
  },
  getSettings: async () => {
    const { data } = await axios.get(`${API}/settings`);
    return data;
  },
  updateSettings: async (settings) => {
    const { data } = await axios.put(`${API}/settings`, { data: settings }, { headers: authHeaders() });
    return data;
  },
  getHomeSlides: async () => {
    const { data } = await axios.get(`${API}/home_slides`);
    return data.slides || [];
  },
  updateHomeSlides: async (slides) => {
    const { data } = await axios.put(`${API}/home_slides`, { slides }, { headers: authHeaders() });
    return data;
  },
  sendContact: async (payload) => {
    const { data } = await axios.post(`${API}/contact`, payload);
    return data;
  },
  listInbox: async () => {
    const { data } = await axios.get(`${API}/inbox`, { headers: authHeaders() });
    return data;
  },
  markMessageRead: async (id) => {
    const { data } = await axios.put(`${API}/inbox/${id}/read`, {}, { headers: authHeaders() });
    return data;
  },
  deleteMessage: async (id) => {
    const { data } = await axios.delete(`${API}/inbox/${id}`, { headers: authHeaders() });
    return data;
  },
  checkout: async (items, email) => {
    const { data } = await axios.post(`${API}/payments/checkout`, {
      items,
      origin_url: window.location.origin,
      email: email || null,
    });
    return data; // { checkout_url, session_id }
  },
  paymentStatus: async (session_id) => {
    const { data } = await axios.get(`${API}/payments/status/${session_id}`);
    return data;
  },
  listOrders: async () => {
    const { data } = await axios.get(`${API}/orders`, { headers: authHeaders() });
    return data;
  },
  updateOrderFulfillment: async (session_id, payload) => {
    const { data } = await axios.put(`${API}/orders/${session_id}/fulfillment`, payload, { headers: authHeaders() });
    return data;
  },
  subscribeNewsletter: async (payload) => {
    const { data } = await axios.post(`${API}/newsletter/subscribe`, payload);
    return data;
  },
  listSubscribers: async () => {
    const { data } = await axios.get(`${API}/newsletter/subscribers`, { headers: authHeaders() });
    return data;
  },
  deleteSubscriber: async (id) => {
    const { data } = await axios.delete(`${API}/newsletter/subscribers/${id}`, { headers: authHeaders() });
    return data;
  },
  adminExport: async () => {
    const { data } = await axios.get(`${API}/admin/export`, { headers: authHeaders() });
    return data;
  },
  adminImport: async (snapshot, opts = {}) => {
    const { data } = await axios.post(
      `${API}/admin/import`,
      { snapshot, mode: opts.mode || "merge", dry_run: !!opts.dryRun },
      { headers: authHeaders() },
    );
    return data;
  },
};

// Convert backend upload URL to fully qualified absolute URL for use in <img src>
export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  return `${BACKEND_URL}${url}`;
};
